import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, RouteReuseStrategy, RouterModule } from '@angular/router';

import { routes } from './app.routes';
import { ParamAwareRouteReuseStrategy } from './utils/param-aware-route-reuse.strategy';
import { provideClientHydration, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { RiterzCoreConfiguration, RiterzCoreModule, authInterceptor } from 'riterz-core';
import { environment } from '../environments/environment';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import AppTheme from './app.theme';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    // Profile pages opt in to being recreated when the organization in the URL
    // changes; everything else keeps Angular's default route reuse.
    { provide: RouteReuseStrategy, useClass: ParamAwareRouteReuseStrategy },
    provideClientHydration(withHttpTransferCacheOptions({
      includePostRequests: true
    })),
    provideHttpClient(withFetch(), withInterceptors([authInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: AppTheme,
        options: {
          darkModeSelector: '.rt-dark'
        }
      }
    }),
    importProvidersFrom(RiterzCoreModule.forRoot({
      apiRoot: environment.riterz_api_url,
      accessTokenName: environment.riterz_access_token_name,
      refreshTokenName: environment.riterz_refresh_token_name,
      clientId: environment.riterz_client_id,
      googleAnalyticsId: environment.google_analytics_id,
      oauthSessionUrl: environment.riterz_oauth_session_url,
    } as RiterzCoreConfiguration)),
    importProvidersFrom(RouterModule.forRoot(routes)),
  ]
};
